import React, { useMemo } from 'react';
import { TitleTextAreaField } from '@warehouse/title/ui';
import { titlePaths } from '@warehouse/title/core';

export function Summary400Field({ localizedInfoUuid }: { localizedInfoUuid: string }) {
	const path = useMemo(() => titlePaths.summary400(localizedInfoUuid), [localizedInfoUuid]);

	return <TitleTextAreaField label="Summary 400" path={path} />;
}
